// One API origin for the store grid, detail page and store profile.
export const API_BASE = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');
const apiOrigin = /^https?:\/\//i.test(API_BASE) ? new URL(API_BASE).origin : '';
export const imageUrl = (value) => {
  if (!value || typeof value !== 'string') return null;
  if (/^https?:\/\//i.test(value)) return value;
  if (/^\/(api\/)?uploads\//.test(value)) return `${apiOrigin}${value}`;
  if (value.startsWith('/server/uploads/')) return `${apiOrigin}${value}`;
  return null;
};

// Shopify's public image CDN supplies bounded derivatives while the saved gallery
// keeps its original source URLs. Other image providers retain their current URLs.
export const productImageUrl = (value, width = 640) => {
  const resolved = imageUrl(value);
  if (!resolved) return null;
  try {
    const url = new URL(resolved);
    if (url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' && url.pathname.startsWith('/s/files/')) {
      url.searchParams.set('width', String(Math.max(80, Math.min(1600, width))));
      return url.toString();
    }
  } catch (_) { /* Local upload path. */ }
  return resolved;
};
